import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalController } from '@ionic/angular';
import { ExpertiseArea } from '../../models/registration.model';
import { TranslatePipe } from '../../pipes/translate.pipe';
import {
  IonHeader, IonToolbar, IonTitle, IonContent, IonGrid, IonRow, IonCol,
  IonButton, IonButtons, IonIcon, IonSearchbar,
  IonFooter,
  IonLabel,
  IonCheckbox,
  IonItem,
  IonList
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-expertise-areas-selection-modal',
  templateUrl: './expertise-areas-selection-modal.component.html',
  styleUrls: ['./expertise-areas-selection-modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule, TranslatePipe, FormsModule, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonButtons, IonIcon, IonSearchbar, IonFooter, IonLabel, IonCheckbox, IonItem, IonList
  ]
})
export class ExpertiseAreasSelectionModalComponent {
  @Input() availableExpertiseAreas: ExpertiseArea[] = [];
  @Input() selectedExpertiseAreas: ExpertiseArea[] = [];

  searchTerm: string = '';

  constructor(private modalController: ModalController) {
    addIcons({ close });
  }

  get filteredAreas(): ExpertiseArea[] {
    if (!this.searchTerm) {
      return this.availableExpertiseAreas;
    }
    return this.availableExpertiseAreas.filter(area =>
      area.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  closeModal() {
    this.modalController.dismiss({
      selectedExpertiseAreas: this.selectedExpertiseAreas
    });
  }

  selectArea(area: ExpertiseArea) {
    const index = this.selectedExpertiseAreas.findIndex(a => a.name === area.name);
    if (index > -1) {
      this.selectedExpertiseAreas.splice(index, 1);
    } else {
      this.selectedExpertiseAreas.push(area);
    }
  }

  isSelected(area: ExpertiseArea): boolean {
    return this.selectedExpertiseAreas.some(a => a.name === area.name);
  }
}